import type { VoyageWorld } from './world';
import type { Vec2 } from './units';

/** Local choices around Murrin are intentionally separate from the twenty-place chart. */
export interface Destination {
  readonly id: 'murrin-nearshore' | 'murrin-outer-shelf';
  readonly label: string;
  readonly position: Vec2;
  readonly purpose: 'quarry' | 'survey';
  readonly promise: string;
  readonly arrivalResultId: string;
  readonly discovered: true;
}

export const MURRIN_DESTINATIONS: readonly Destination[] = Object.freeze([
  {
    id: 'murrin-nearshore', label: 'Murrin Nearshore', position: { x: -8, y: -12 },
    purpose: 'quarry', promise: 'Study the quarry you have chosen in the sheltered ground.',
    arrivalResultId: 'murrin-nearshore-quarry-ground', discovered: true,
  },
  {
    id: 'murrin-outer-shelf', label: 'Murrin Outer Shelf', position: { x: 18, y: -16 },
    purpose: 'survey', promise: 'Survey the shelf and mark its changing water.',
    arrivalResultId: 'murrin-outer-shelf-survey-mark', discovered: true,
  },
]);

export function destinationById(world: VoyageWorld, id: string): Destination | undefined {
  return world.destinations.find(destination => destination.id === id);
}
